//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const consola = require('consola'); consola.level = process.env.CONSOLA_LEVEL;

export default {
	props:
	{
		count:
		{
			type: Number,
			default: 1
		},
		exclusive:
		{
			type: Boolean,
			default: true,
		}
	},

	data()
	{
		return {
			maxHeight: [],
			disableAnims: false,
		}
	},

	watch:
	{
		count(newVal)
		{
			// consola.debug('accordion count: ', newVal)
			// this.$nextTick( ()=>
			// {
			// } )

			this.maxHeight = Array(newVal).fill(0).map(x => 0);
		}
	},

	created()
	{
		this.maxHeight = Array(this.count).fill(0).map(x => 0);
	},

	methods:
	{
		toggle(event, index)
		{
			// consola.debug('toggle ', index)
			let list = [...this.maxHeight]
			let prevHeight = list[index]
			if (this.exclusive)
			{
				list = list.map(x => 0);
			}

			if (prevHeight > 0)
			{
				list[index] = 0
			}
			else
			{
				// debugger;
				let elems = this.$refs.accordion_root.querySelectorAll('.Accordion__item-body');
				// list[index] = this.$refs.item[index].querySelector('.Accordion__item-body').scrollHeight;
				list[index] = elems[index].scrollHeight;
			}

			this.maxHeight = list;
		},

		closeAll()
		{
			this.disableAnims = true
			this.$nextTick(()=> {
				this.maxHeight = Array(this.count).fill(0);
				// consola.debug('maxHeight: ', this.maxHeight)

				setTimeout(() => {
					this.disableAnims = false;
				}, 100);

				// this.$nextTick(()=> {
				// 	this.disableAnims = false;
				// })

			})
		}
	}
}
